import axios from "axios";
import React, { useEffect, useState } from "react";

const StationList = ({ activeStation, setActiveStation, sec, setSec }) => {
  const [stations, setStations] = useState([]);
  const [stationList, setStationList] = useState([]);
  // const [sec, setSec] = useState("");

  const section = [...new Set(stations.map((o) => o.section))];
  const [error, setError] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const urlBlockPrefix = process.env.REACT_APP_URL_BLOCK_PREFIX;

  const fetchstation = async () => {
    try {
      const response = await axios.get(`${urlBlockPrefix}getstationcode`);
      if (response.data.status === "ok") {
        setStations(response.data.data);
      }
    } catch (err) {
      console.error("Failed to fetch stations", err);
      setError(true);
    }
  };

  useEffect(() => {
    fetchstation();
  }, []);

  useEffect(() => {
    if (!sec) return;

    const a = stations.filter((o) => o.section === sec);

    const stationList = [...new Set(a.map((e) => e.station_code))]
      .sort()
      .filter((station) =>
        station.toLowerCase().includes(searchTerm.toLowerCase()),
      );

    setStationList(stationList);
  }, [sec, searchTerm, stations]);

  return (
    <div className="card shadow-sm border-0 rounded-4">
      {/* HEADER */}
      <div
        className="card-header text-center fw-semibold rounded-top-4"
        style={{
          background: "linear-gradient(135deg, #f8c4b7, #fbede0)",
          color: "#3d1326",
        }}
      >
        Select Section & Station
      </div>

      <div className="card-body">
        {/* SECTION SELECT */}
        <select
          className="form-select rounded-pill text-center mb-3"
          value={sec}
          onChange={(e) => setSec(e.target.value)}
        >
          <option value="" hidden>
            Select Section
          </option>
          {section.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>

        {sec && (
          <>
            {/* SEARCH */}
            <div className="input-group mb-3">
              <span className="input-group-text bg-white border-end-0 rounded-start-pill">
                🔍
              </span>
              <input
                type="text"
                className="form-control border-start-0 rounded-end-pill"
                placeholder="Search station..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            {/* STATION LIST */}
            <div
              className="p-2 rounded-4"
              style={{
                maxHeight: "50vh",
                overflowY: "auto",
                background: "rgba(251, 237, 224, 0.45)",
              }}
            >
              {stationList.length > 0 ? (
                stationList.map((station) => (
                  <div
                    key={station}
                    onClick={() => setActiveStation(station)}
                    className={`px-3 py-2 mb-2 rounded-pill shadow-sm d-flex justify-content-between align-items-center ${
                      activeStation === station ? "fw-semibold" : ""
                    }`}
                    style={{
                      cursor: "pointer",
                      background:
                        activeStation === station
                          ? "linear-gradient(135deg, #f0bb8a, #f8c4b7)"
                          : "#ffffff",
                      transition: "all 0.25s ease",
                    }}
                  >
                    <span>{station}</span>
                    {activeStation === station && <span>✔</span>}
                  </div>
                ))
              ) : (
                <div className="text-center text-muted py-3">
                  No stations found
                </div>
              )}
            </div>
          </>
        )}

        {error && (
          <div className="text-danger text-center mt-3">
            Failed to load stations
          </div>
        )}
      </div>
    </div>
  );
};

export default StationList;
